/**
 * [INPUT]: 依赖 @/zinnercms-design-system/lib/utils 的 cn 与 index.css 唯一 shimmer 底色/速度令牌
 * [OUTPUT]: 对外提供低对比扫光 Skeleton 组件
 * [POS]: zinnercms-design-system/ui 的骨架屏原子，尺寸由调用方决定，材质与 compositor 扫光只由 skeleton-shimmer 接管
 * [PROTOCOL]: 变更时更新此头部，然后检查 CLAUDE.md
 */
import { cn } from "@/zinnercms-design-system/lib/utils"

function Skeleton({
  className,
  ...props
}) {
  return (
    <div
      data-slot="skeleton"
      className={cn("skeleton-shimmer rounded-md border border-border/60", className)}
      {...props} />
  );
}

export { Skeleton }
